/* ============================================
   Header - Sticky, Mobile Menu, Cart Toggle
   ============================================ */

class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.header');
    this.menuDrawer = this.querySelector('[data-menu-drawer]');
    this.menuToggle = this.querySelector('[data-menu-toggle]');
    this.menuClose = this.querySelector('[data-menu-close]');
    this.cartToggle = this.querySelector('[data-cart-toggle]');
    this.isSticky = this.dataset.sticky === 'true';
    this.lastScrollY = 0;
  }

  connectedCallback() {
    if (this.isSticky) {
      this.onScroll = FuzeTheme.throttle(() => this.handleScroll(), 50);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.handleScroll();
    }

    this.menuToggle?.addEventListener('click', () => this.openMenu());
    this.menuClose?.addEventListener('click', () => this.closeMenu());
    this.menuDrawer?.addEventListener('click', (e) => {
      if (e.target === this.menuDrawer) this.closeMenu();
    });

    this.cartToggle?.addEventListener('click', (e) => {
      const cartType = document.body.dataset.cartType || 'drawer';
      if (cartType === 'drawer') {
        e.preventDefault();
        FuzeTheme.FuzeEvents.emit('cart:toggle');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.menuDrawer?.getAttribute('aria-hidden') === 'false') {
        this.closeMenu();
      }
    });
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const isScrolled = scrollY > 50;
    this.classList.toggle('header-wrapper--scrolled', isScrolled);
    this.lastScrollY = scrollY;
  }

  openMenu() {
    this.menuDrawer.setAttribute('aria-hidden', 'false');
    this.menuToggle.setAttribute('aria-expanded', 'true');
    FuzeTheme.lockScroll();
    this.removeFocusTrap = FuzeTheme.trapFocus(this.menuDrawer, this.menuClose);
  }

  closeMenu() {
    this.menuDrawer.setAttribute('aria-hidden', 'true');
    this.menuToggle.setAttribute('aria-expanded', 'false');
    FuzeTheme.unlockScroll();
    this.removeFocusTrap?.();
    this.menuToggle.focus();
  }

  disconnectedCallback() {
    if (this.onScroll) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
}

customElements.define('sticky-header', StickyHeader);
